import React from 'react';
import { Box, Typography } from '@mui/material';
import './FeatureSecondPage.scss';
import svgIcon from '../../../assets/Images/Unlimitedmusicsign.svg'; // Ensure the path is correct
import UnifiedButton from '../../shared/Button';
import { useNavigate } from 'react-router-dom';

const playlists = [
    {
        name: 'Best of Karan Aujla',
        embedUrl: 'https://open.spotify.com/embed/playlist/75Obxsxfbo9lyQ6uyZeZe3?utm_source=generator',
        coverImage: 'https://i.scdn.co/image/ab67616d0000b273bcfb3e88506a4d2b382999cf',
    },
    {
        name: 'FM Digital Official Portfolio',
        embedUrl: 'https://open.spotify.com/embed/playlist/5wNsrgUinQNpAUPdVMB1D4?si=80c4bb4ade824a07',
        coverImage: 'https://i.scdn.co/image/ab67616d0000b273b9ecb12f74a926c915645c37',
    },
    {
        name: 'Best of Anuv Jain',
        embedUrl: 'https://open.spotify.com/embed/playlist/2hlZ91gSmaTKasVDZPimDo?si=36v6PrW-REmatqs0E9THDg',
        coverImage: 'https://i.scdn.co/image/ab67616d0000b273d0c5f45d2fc624942f42c70e',
    },
    {
        name: 'The Rajput songs',
        embedUrl: 'https://open.spotify.com/embed/playlist/4cc5K04DuPJAYmzr8AgYMf?si=-VHR3QL0T8SMq5r994RKvQ',
        coverImage: 'https://i.scdn.co/image/ab67616d0000b273abf51db85cceeb5ed78594ac',
    },
    {
        name: 'Yo Yo Honey Singh',
        embedUrl: 'https://open.spotify.com/embed/playlist/12C236rl1bGUuG0CiyOlUK?si=-yrUbMq3RQeUFSNXVkaETw',
        coverImage: 'https://i.scdn.co/image/ab67616d0000b2733d0b7e5cc550fa8a9b57b309',
    },
    {
        name: 'Best of Vishal Mishra',
        embedUrl: 'https://open.spotify.com/embed/playlist/75jUoxGDIGLLvQKk9wSD01?si=6S2pKeJAS_ub2ZQ1rFsceQ',
        coverImage: 'https://i.scdn.co/image/ab67616d0000b273a9f3b2552cc35dc6bf5df233',
    },
    {
        name: 'Best Of Punjabi songs',
        embedUrl: 'https://open.spotify.com/embed/playlist/57cKHRj9m2AwcR2DEgRz5d?si=Z3dHu9EORf65ZdlCnOFcGg',
        coverImage: 'https://i.scdn.co/image/ab67616d0000b27325fc788b1d5a2938f8a7e4e3',
    },
    {
        name: `It's Freestyle time`,
        embedUrl: 'https://open.spotify.com/embed/playlist/09XswLXTBt6qt1UIVEA139?si=qomvi41ATS28gnV_xUo-yQ',
        coverImage: 'https://i.scdn.co/image/ab67616d0000b2737c1d2850e58af1f5f317c391',
    },
];

const FeatureSecondPage = () => {

    const navigate = useNavigate()

    const handleplaylistformClick = () => {
        console.log('Navigating to /pricing');
        navigate('/support/legal-forms/2');
        window.scrollTo(0, 0);
    };
    // Function to handle the image click
    const handleImageClick = (embedUrl) => {
        // Remove 'embed' from URL and replace it with 'playlist' for proper Spotify URL
        const playlistUrl = embedUrl.replace('/embed/', '/');
        window.open(playlistUrl, '_blank'); // Open the playlist in a new tab
    };

    return (
        <Box className="feature-second-page">
            <Box className="feature-second-page-header">
                <img src={svgIcon} alt="Icon" className="icon" />
                <Box>
                    <Typography variant="h5" className="title">
                        Tracks chosen for playlists with our support team’s assistance.
                    </Typography>
                    <Typography variant="body2" className="subtitle">
                        To 190+ Stores Worldwide for Free
                    </Typography>
                </Box>
            </Box>

            <Box className="playlists">
                {playlists.map((playlist, index) => (
                    <Box
                        key={index}
                        className="playlist-box"
                        onClick={() => handleImageClick(playlist.embedUrl)} // Trigger on click
                        style={{ cursor: 'pointer' }} // Indicate it's clickable
                    >
                        {/* Display the cover image */}
                        <Box className="playlist-cover-box">

                            <iframe
                                title={playlist.name}
                                src={playlist.embedUrl}
                                width="100%"
                                height="352"
                                frameBorder="0"
                                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                style={{ borderRadius: '12px', marginTop: '10px' }}
                            ></iframe>
                            {/* <img src={playlist.coverImage} alt={playlist.name} className="playlist-cover-image" /> */}
                        </Box>

                        {/* Playlist name below the image */}
                        <Typography variant="h6" className="playlist-name">{playlist.name}</Typography>
                    </Box>
                ))}
            </Box>

            <UnifiedButton onClick={handleplaylistformClick} className="submit-button" textContent={"Submit your song now"} />
        </Box>
    );
};

export default FeatureSecondPage;
